// extracted by mini-css-extract-plugin
module.exports = {"loaderWrap":"tj8Sv"};